import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class DayofWeekService {
  url=ConfigService.toApiUrl("get-dows/");

  constructor(private http:HttpClient) { }

  
  getDows(){
    return this.http.get<any>(`${this.url}`,
     ConfigService.addAction('list'));
  }
}
